import { render } from "./WalletInstructions.vue?vue&type=template&id=74331651"
import script from "./WalletInstructions.vue?vue&type=script&lang=js"
export * from "./WalletInstructions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__